"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var react_1 = __importDefault(require("react"));

var enums_1 = require("../../enums");

var styled_1 = require("../styled");

var TermsAndConditionsBoxComponent =
/** @class */
function (_super) {
  __extends(TermsAndConditionsBoxComponent, _super);

  function TermsAndConditionsBoxComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      modalVisible: false
    };

    _this.handleCheckBoxClick = function () {
      var _a = _this.props,
          setFieldValue = _a.setFieldValue,
          setFieldTouched = _a.setFieldTouched,
          values = _a.values,
          isSubmitting = _a.isSubmitting;

      if (!isSubmitting) {
        setFieldValue(enums_1.FieldNames.termsAccepted, !values.termsAccepted);
        setFieldTouched(enums_1.FieldNames.termsAccepted);
      }
    };

    _this.handleComplianceCheckBoxClick = function () {
      var _a = _this.props,
          setFieldValue = _a.setFieldValue,
          setFieldTouched = _a.setFieldTouched,
          values = _a.values,
          isSubmitting = _a.isSubmitting;

      if (!isSubmitting) {
        setFieldValue(enums_1.FieldNames.complianceTermsAccepted, !values.complianceTermsAccepted);
        setFieldTouched(enums_1.FieldNames.complianceTermsAccepted);
      }
    };

    return _this;
  }

  TermsAndConditionsBoxComponent.prototype.render = function () {
    var _a = this.props,
        errors = _a.errors,
        touched = _a.touched,
        values = _a.values,
        showTerms = _a.showTerms;
    var signupCodeParamAvailable = false;
    var params = core_1.locationWebService.parseQueryParams(core_1.locationWebService.location.search);

    if (params && Object.keys(params).length > 0) {
      signupCodeParamAvailable = true;
    }

    return react_1.default.createElement(styled_1.TermsWrapper, null, react_1.default.createElement(components_lib_1.RowWrapper, {
      wrap: true,
      justify: 'center'
    }, react_1.default.createElement(components_lib_1.CheckBox, {
      isChecked: values.termsAccepted,
      action: this.handleCheckBoxClick,
      tabIndex: 0,
      accessibilityLabel: "Agree to terms and conditions checkbox",
      selectedAccessibilityLabel: "Selected: Agree to terms and conditions checkbox"
    }), react_1.default.createElement(components_lib_1.Paragraph, {
      size: components_lib_1.ParagraphSizeEnum.normal
    }, "I agree to KolbeYouthIndex.com's "), react_1.default.createElement(components_lib_1.TextLink, {
      onPress: showTerms
    }, "Terms & Conditions")), signupCodeParamAvailable && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_lib_1.RowWrapper, {
      wrap: true,
      justify: 'center'
    }, react_1.default.createElement(components_lib_1.CheckBox, {
      isChecked: values.complianceTermsAccepted,
      action: this.handleComplianceCheckBoxClick,
      tabIndex: 0,
      accessibilityLabel: "Agree to compliance terms and conditions"
    }), react_1.default.createElement(components_lib_1.Paragraph, {
      size: components_lib_1.ParagraphSizeEnum.normal
    }, "I agree to KolbeYouthIndex.com's "), react_1.default.createElement(components_lib_1.TextLink, null, "Result Access Disclaimer")), react_1.default.createElement(components_lib_1.RowWrapper, {
      wrap: true,
      justify: 'flex-end',
      align: 'center',
      style: {
        width: '600px'
      }
    }, react_1.default.createElement(components_lib_1.Paragraph, {
      size: components_lib_1.ParagraphSizeEnum.extraSmall
    }, "Disclaimer: The information you provide here, including any Kolbe Y\u2122 Index results generated from that information, will be accessible to Kolbe Corp and may also be accessed by a third party or its representatives for which Kolbe Corp created the Access Code you are using. Your use of this site gives your permission for Kolbe Corp, the third party mentioned above, and its representatives to access the information you provide. We will not share that information with any additional parties."))), touched[enums_1.FieldNames.termsAccepted] && errors[enums_1.FieldNames.termsAccepted] && react_1.default.createElement(components_lib_1.RowWrapper, {
      wrap: true,
      justify: 'center'
    }, react_1.default.createElement(components_lib_1.RenderError, {
      errorText: errors[enums_1.FieldNames.termsAccepted]
    })), !values.complianceTermsAccepted && signupCodeParamAvailable && react_1.default.createElement(components_lib_1.RowWrapper, {
      wrap: true,
      justify: 'center'
    }, react_1.default.createElement(components_lib_1.Paragraph, {
      size: components_lib_1.ParagraphSizeEnum.small,
      color: '#FF5348'
    }, "Please review and accept the Results Access Disclaimer to proceed")));
  };

  return TermsAndConditionsBoxComponent;
}(react_1.default.Component);

exports.TermsAndConditionsBoxComponent = TermsAndConditionsBoxComponent;
exports.default = TermsAndConditionsBoxComponent;